(() => {
  const data = document.getElementById('er-guatemala-transition-data');
  if (!data) return;
  let groups;
  try {
    groups = JSON.parse(data.textContent);
  } catch {
    return;
  }
  const entries = new Map([...(groups.full || []), ...(groups.sample || [])].map((entry) => [entry.oldId, entry]));
  if (!entries.size) return;

  const replacement = (href) => {
    let source;
    try {
      source = new URL(href, window.location.href);
    } catch {
      return null;
    }
    if (source.origin !== window.location.origin) return null;
    const entry = entries.get(source.searchParams.get('variant'));
    if (!entry || !source.pathname.replace(/\/$/, '').endsWith(`/products/${entry.oldHandle}`)) return null;
    const target = new URL(entry.url, source);
    const variant = target.searchParams.get('variant');
    if (target.origin !== source.origin || !variant) return null;
    target.search = source.search;
    target.searchParams.set('variant', variant);
    target.searchParams.delete('option_values');
    target.hash = source.hash;
    return target;
  };

  const target = replacement(window.location.href);
  if (target) {
    window.location.replace(target.href);
    return;
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download')) return;
    const next = replacement(link.href);
    if (next) link.href = next.href;
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !/\/cart\/add(?:\.js)?$/.test(action.pathname)) return;
    const fields = new FormData(form);
    const entry = entries.get(String(fields.get('id')));
    if (!entry) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const next = new URL(entry.url, window.location.href);
    const plan = fields.get('selling_plan');
    if (plan) next.searchParams.set('selling_plan', String(plan));
    const quantity = String(fields.get('quantity') || '');
    if (/^[1-9]\d*$/.test(quantity) && Number.isSafeInteger(Number(quantity))) {
      next.searchParams.set('quantity', quantity);
    }
    window.location.assign(next.href);
  }, true);
})();
